import React, { useEffect, useState } from 'react';
import { apiCall } from '../App';

const PLANS = [
  { key: 'free', name: 'Free', price: '$0', period: 'forever', integrations: 3, highlight: false,
    features: ['3 integrations', '1-minute polling', 'Email alerts', '7-day history', 'Basic dashboard'] },
  { key: 'micro', name: 'Micro', price: '$2', period: '/month', integrations: 1, highlight: false,
    features: ['1 integration', '1-minute polling', 'Email alerts', '30-day history', 'Perfect for indie hackers'] },
  { key: 'pro', name: 'Pro', price: '$29', period: '/month', integrations: 10, highlight: true,
    features: ['10 integrations', '30-second polling', 'Email + Slack alerts', 'Smart predictive alerts', '90-day history', 'Priority support'] },
  { key: 'growth', name: 'Growth', price: '$79', period: '/month', integrations: 25, highlight: false,
    features: ['25 integrations', '30-second polling', 'All alert channels', 'AI / LLM monitoring', 'Multi-region checks', '1-year history'] },
  { key: 'business', name: 'Business', price: '$299', period: '/month', integrations: 999, highlight: false,
    features: ['Unlimited integrations', '10-second polling', 'All features', 'Custom connectors', 'Dedicated support', 'SLA guarantee'] },
];

export default function Billing() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [upgrading, setUpgrading] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const res = await apiCall('/api/billing/status');
        setStatus(res);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  async function handleUpgrade(planKey) {
    if (planKey === 'free') return;
    setUpgrading(planKey);
    try {
      const res = await apiCall('/api/billing/create-checkout', { method: 'POST', body: { plan: planKey } });
      if (res.comingSoon) {
        alert(`Payments coming soon!\n\nFor early access to the ${planKey} plan, email: rahulchidipudi45@gmail.com\n\nWe'll set you up manually and give you a discount!`);
      } else if (res.url) {
        window.location.href = res.url;
      }
    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setUpgrading(null);
    }
  }

  if (loading) return <div className="page-loading"><div className="spinner" /></div>;

  const currentPlan = status?.plan || 'free';

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Billing</h1>
          <p className="page-sub">
            Current plan: <strong style={{ color: 'var(--purple-2)' }}>{currentPlan}</strong>
            {status?.currentPeriodEnd && ` · Renews ${new Date(status.currentPeriodEnd).toLocaleDateString()}`}
          </p>
        </div>
      </div>

      <div style={{ background: 'var(--purple-dim)', border: '1px solid var(--purple-glow)', borderRadius: 10, padding: '14px 18px', marginBottom: 20, fontSize: 13, color: 'var(--purple-2)', lineHeight: 1.7 }}>
        <strong>Payments launching soon.</strong> To upgrade early, email <strong>rahulchidipudi45@gmail.com</strong> with your desired plan — you'll get a founder discount.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, marginBottom: 20 }}>
        {PLANS.map(plan => {
          const isCurrent = currentPlan === plan.key;
          return (
            <div key={plan.key} className={`plan-card ${plan.highlight ? 'plan-highlight' : ''}`}>
              {plan.highlight && <div className="plan-badge">Most popular</div>}
              <div className="plan-name">{plan.name}</div>
              <div className="plan-price">{plan.price}<span className="plan-period">{plan.period}</span></div>
              <div className="plan-integrations">{plan.integrations === 999 ? 'Unlimited' : plan.integrations} integration{plan.integrations !== 1 ? 's' : ''}</div>
              <ul className="plan-features">
                {plan.features.map(f => (
                  <li key={f}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6l3 3 5-5" stroke="var(--green)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                className={`plan-btn ${isCurrent ? 'plan-btn-current' : plan.highlight ? 'btn-primary' : 'btn-secondary'}`}
                style={plan.highlight && !isCurrent ? { background: 'var(--purple)', color: '#fff', border: 'none' } : {}}
                onClick={() => !isCurrent && handleUpgrade(plan.key)}
                disabled={isCurrent || upgrading === plan.key}
              >
                {isCurrent ? 'Current plan' : upgrading === plan.key ? 'Loading...' : `Get ${plan.name}`}
              </button>
            </div>
          );
        })}
      </div>

      <div className="card">
        <h2 className="card-title" style={{ marginBottom: 8 }}>Enterprise</h2>
        <p style={{ fontSize: 13, color: 'var(--text-3)', marginBottom: 12, lineHeight: 1.6 }}>
          Unlimited integrations, on-premise deployment, SSO, custom SLA, dedicated engineer, and white-label options for MSPs.
        </p>
        <a href="mailto:rahulchidipudi45@gmail.com?subject=IntegratePulse Enterprise" className="btn-secondary" style={{ display: 'inline-flex' }}>
          Contact for pricing
        </a>
      </div>
    </div>
  );
}
